import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/contexts/AuthContext";
import { SiteProvider } from "@/contexts/SiteContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Sites from "@/pages/Sites";
import Audit from "@/pages/Audit";
import Generator from "@/pages/Generator";
import Drafts from "@/pages/Drafts";
import DraftDetail from "@/pages/DraftDetail";
import ContentParents from "@/pages/ContentParents";
import ContentParentDetail from "@/pages/ContentParentDetail";
import HistoryPage from "@/pages/History";
import Performance from "@/pages/Performance";
import GscInsights from "@/pages/GscInsights";
import Reports from "@/pages/Reports";
import Automation from "@/pages/Automation";
import Workflows from "@/pages/Workflows";
import Billing from "@/pages/Billing";
import Keywords from "@/pages/Keywords";
import Optimizer from "@/pages/Optimizer";
import AIVisibility from "@/pages/AIVisibility";
import KeywordIntelligence from "@/pages/KeywordIntelligence";
import Aide from "@/pages/Aide";
import BusinessAnalyzer from "@/pages/BusinessAnalyzer";
import Competitors from "@/pages/Competitors";
import GoogleBusiness from "@/pages/GoogleBusiness";
import Team from "@/pages/Team";
import Admin from "@/pages/Admin";
import Confidentialite from "@/pages/Confidentialite";
import Conditions from "@/pages/Conditions";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SiteProvider>
          <Toaster richColors position="top-right" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/register" element={<Register />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/conditions" element={<Conditions />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/sites" element={<Sites />} />
              <Route path="/audit" element={<Audit />} />
              <Route path="/ai-visibility" element={<AIVisibility />} />
              <Route path="/keywords" element={<Keywords />} />
              <Route path="/keyword-intelligence" element={<KeywordIntelligence />} />
              <Route path="/business" element={<BusinessAnalyzer />} />
              <Route path="/competitors" element={<Competitors />} />
              <Route path="/google-business" element={<GoogleBusiness />} />
              <Route path="/optimizer" element={<Optimizer />} />
              <Route path="/generator" element={<Generator />} />
              <Route path="/drafts" element={<Drafts />} />
              <Route path="/drafts/:id" element={<DraftDetail />} />
              <Route path="/content-parents" element={<ContentParents />} />
              <Route path="/content/parents/:id" element={<ContentParentDetail />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/performance" element={<Performance />} />
              <Route path="/gsc-insights" element={<GscInsights />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/automation" element={<Automation />} />
              <Route path="/workflows" element={<Workflows />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/team" element={<Team />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/aide" element={<Aide />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </SiteProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
